import{IconDash300 as e}from"../src/elements/IconDash300.js";customElements.define("sp-icon-dash300",e);
//# sourceMappingURL=sp-icon-dash300.js.map
